import { render, staticRenderFns } from "./OportunidadesEquipo.vue?vue&type=template&id=7b0d23ca&"
import script from "./OportunidadesEquipo.vue?vue&type=script&lang=js&"
export * from "./OportunidadesEquipo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports